import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SiteDto } from '@app/admin/models/site-dto';

export const buildSiteForm = (formBuilder: UntypedFormBuilder, site: SiteDto): UntypedFormGroup => {
  const form = formBuilder.group({
    id: [{ value: '', disabled: true }, Validators.required],
    name: ['', Validators.required],
    plantCode: ['', Validators.required],
  });

  form.patchValue(site);

  return form;
};
